import React, { useContext, useRef } from 'react'
import { mobile } from '../../../services/agent';
import { ga_push, vPush } from '../../../services/analytics';
import { isExist } from '../../../services/fetch';
import { LEAD_ID } from '../../../services/urls';
import { formValid } from '../../../services/validate';
import { AppContext } from '../../../stores/application.store';
import { User } from '../../../types/Application';
import "./StartPage.scss";

const StartPage = () => {

    const { setCurrentUser, loading, setLoading, setPageView, setQuizTime, quizData } = useContext(AppContext)!;

    const emailRef = useRef<HTMLInputElement>(null);
    const phoneRef = useRef<HTMLInputElement>(null);
    const fullNameRef = useRef<HTMLInputElement>(null);
    const ageRef = useRef<HTMLInputElement>(null);
    const consoleRef = useRef<HTMLSelectElement>(null);
    const tosRef = useRef<HTMLInputElement>(null);

    const SubmitButtonClicked = () => {

        if (!tosRef.current!.checked) {
            alert("נדרש להסכים לתנאי השימוש, למדיניות הפרטיות, לתקנון הפעילות, וכן למשלוח דברי פרסום")
            return;
        }

        const formData: User = {
            LeadID: LEAD_ID,
            FullName: fullNameRef.current!.value,
            PhoneNumber: phoneRef.current!.value,
            Age: ageRef.current!.value,
            Email: emailRef.current!.value,
            PlainText: consoleRef.current!.value,
        }

        if (formValid(formData)) {
            isExist(formData, () => {
                setLoading(true);
            },
                () => {
                    setLoading(false);
                },
                () => {
                    setCurrentUser(formData);
                    setQuizTime(new Date());
                    setPageView("questions");
                    ga_push("ga_events", "FIFA", "Quiz", "Start Quiz");
                    if(mobile()){
                        vPush("question-1", `חידון פיפה - ${quizData?.Questions[0].Text}`);
                    } else {
                        vPush("question1to6", `חידון פיפה - שאלות 1 עד 6`)
                    }
                }, () => {
                    setCurrentUser(formData);
                    setPageView("once");
                })
        }


    }


    return (
        <section className="start-page">
            <div className="image"></div>
            <div className="form">
                <input type="text" placeholder="שם מלא" ref={fullNameRef}></input>
                <input type="number" className="age" placeholder="גיל" ref={ageRef}></input>
                <input type="email" placeholder="אימייל" ref={emailRef}></input>
                <input type="tel" placeholder="טלפון" ref={phoneRef}></input>
                <select ref={consoleRef}>
                    <option value="">קונסולת המשחקים שלכם</option>
                    <option value="ps4">PlayStation®PS4 </option>
                    <option value="xbox">Xbox One</option>
                    <option value="switch">Nintendo Switch</option>
                </select>
                <button className={`hide-mobile ${loading ? "loading" : ""}`} onClick={SubmitButtonClicked}></button>
                <div className="tos-wrapper">
                    <input type="checkbox" id="tos" ref={tosRef}></input>
                    <label htmlFor="tos">
                        קראתי, הבנתי, ומסכים {" "}
                        <a href="https://z.ynet.co.il/short/content/2018/privacypolicy/terms.html" target="_blank" rel="noopener noreferrer">לתנאי השימוש</a>
                        , {" "}
                        <a href="https://z.ynet.co.il/short/content/2018/privacypolicy/policy.html" target="_blank" rel="noopener noreferrer">למדיניות הפרטיות</a>
                        , {" "}
                        <a href="http://z.ynet.co.il/mShort/generics/Leads/TOS/86/" target="_blank" rel="noopener noreferrer">
                            ולתקנון הפעילות
                        </a>
                        ,
                         וכן נותן הסכמתי למשלוח דברי פרסום לפי פרטיי לעיל
                </label>
                </div>
                <button className={`hide-desktop ${loading ? "loading" : ""}`} onClick={SubmitButtonClicked}></button>
            </div>
        </section>
    )
}

export default StartPage
